import { Box, Button } from '@mui/material'
import React from 'react'
import sizeFontCustom from "../Discovery/fontSize.styles"
import { useTranslation } from '../../hooks/useTranslation'

function DenyConsent({handleCancel, handleDeny, isDarkTheme}) {
  const { t } = useTranslation();
  return (
        <Box sx={{ display: { xs: "flex" } }}>
          <Button
            variant='text' 
            color='error' 
            onClick={handleDeny}
            sx={{
              width: "80%",
              height: "2rem",
              textTransform: "none",
              fontWeight: 600,
              ...sizeFontCustom.heading,
              backgroundColor: isDarkTheme ? 'transparent !important' : '#ffffff !important',
              color: '#E94B4B !important',
              borderColor: '#E94B4B !important',
              '&:hover': {
                backgroundColor: 'rgba(233, 75, 75, 0.04) !important',
                borderColor: '#E94B4B !important',
              },
              marginRight: '1rem'
            }}
          >
            {t('common.buttons.deny')}
          </Button>
          <Button
            variant="contained"
            onClick={handleCancel}
            sx={{
              width: "80%",
              height: "2rem",
              textTransform: "none",
              fontWeight: 600,
              ...sizeFontCustom.heading

            }}
          >
            {t('common.buttons.cancel')}
          </Button>
          
    </Box>  )
}

export default DenyConsent